import React, { useEffect } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import AOS from "aos";
import "aos/dist/aos.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// Import required modules
import { Autoplay, Pagination } from "swiper/modules";

//Import Slider Images
import slider1 from "../../../assets/images/1.webp";
import slider2 from "../../../assets/images/2.webp";
import slider3 from "../../../assets/images/3.webp";
import slider4 from "../../../assets/images/4.webp";
import slider5 from "../../../assets/images/5.webp";
import slider6 from "../../../assets/images/6.webp";
import slider7 from "../../../assets/images/7.webp";
import slider8 from "../../../assets/images/8.webp";

// Import custom CSS
import "./styles.css";

export default function BackgroundSwiper() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      easing: "ease-in-out", // Animation easing
      once: false,
      offset: 100, // Trigger when the element is 100px from the viewport
      delay: 200, // Trigger animation only once
    });
  }, []);

  return (
    <div className="mb-20 ">
      {/* Swiper Background */}
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
      >
        <SwiperSlide>
          <img
            src={slider1}
            alt="Basketball"
            className="w-full h-auto object-cover"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slider2}
            alt="Table Tennis"
            className="w-full h-auto object-cover opacity-90"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slider3}
            alt="Squash"
            className="w-full h-auto object-cover"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slider4}
            alt="Squash"
            className="w-full h-auto object-cover"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slider5}
            alt="Squash"
            className="w-full h-auto object-cover"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slider6}
            alt="Squash"
            className="w-full h-auto object-cover"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slider7}
            alt="Squash"
            className="w-full h-auto object-cover"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slider7}
            alt="Squash"
            className="w-full h-auto object-cover"
          />
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
